import Link from "next/link";
import { memo, PropsWithChildren } from "react";

interface BoxContentLinkProps extends PropsWithChildren {
	href?: string;
	title?: string;
}
const BoxContentLink: React.FC<BoxContentLinkProps> = ({
	children,
	href,
	title,
}) => {
	return href ? (
		<Link href={href} title={title}>
			{children}
		</Link>
	) : (
		children
	);
};

export default memo(BoxContentLink);
